export default __webpack_public_path__ + "static/media/srboiNgirl.cfe5f5c0.jpeg";